import React, { useEffect } from 'react';
import { Grid, Radio, Checkbox, Divider, FormControlLabel, Box, Typography, RadioGroup, Paper } from '@mui/material';
import * as PXBColors from '@brightlayer-ui/colors';
import { isDataLoaded } from '../../types';
import { PhaseResolvedGraphProvider } from '../../data/DataProviders/PhaseResolvedDataProvider';
import { PhaseResolvedGraph } from '../PhaseResolvedChartView/PhaseResolvedGraph';
import { useDatetimeData } from '../../data/DataProviders/DatetimeListDataProvider';
import { DataIndicators } from '../DataIndicators';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { DataEmptyIndicator } from '../DataEmptyIndicator';
import { HeaderPRGraph } from './HeaderPRGraph';
import makeStyle from '@mui/styles/makeStyles';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';

const useStyles = makeStyle(() => ({
    boxContent: {
        backgroundColor: PXBColors.black[800],
        width: 20,
        height: 20,
        marginBottom: '20px',
    },
    colorSpan: {
        position: 'absolute',
        margin: '0px 30px',
    },

    headerCont: {
        fontSize: '14px',
        fontFamily: 'open sans',
        letterSpacing: 2,
        lineHeight: '20px',
        paddingBottom: 0,
    },
}));

export const PhaseResolvedGraphOverview: React.FC<{
    deviceId: string;
    isDisabled?: boolean;
    alarnChannelNumber?: any;
    alarmGraphDate?: any;
    alarmDetail?: boolean;
    channelName?: string;
}> = (props) => {
    const classes = useStyles();
    const getResponseData = useDatetimeData();
    const { t } = useLanguageLocale();
    const currentAppRoute = useCurrentAppRoute();

    const tabDate: any =
        currentAppRoute.type === 'TimelineSiteTabDetails' ||
        currentAppRoute.type === 'TimelineLocationTabDetails' ||
        currentAppRoute.type === 'TimelineOrganizationTabDetails'
            ? currentAppRoute.phaseDate
            : 0;
     const finalDate = tabDate === '-1' ? 0 : tabDate;
    

    const isEmpty = isDataLoaded(getResponseData) ? getResponseData.value.datesWithChannel.length === 0 : false;
    const [selectedDateIndex, setdateTimeList] = React.useState(0);
    const [scaleIndex, setScaleIndex] = React.useState(0);
    const [filterchecked, setFilterChecked] = React.useState(false);
    const [pdConversion, setPdConversion] = React.useState('Magn,mV');
    let emptyChannels = false;
    const dataItem: any = [];
    let datesWithChannelResult: any = [];
    if (isDataLoaded(getResponseData)) {
        datesWithChannelResult = getResponseData.value.datesWithChannel;
        datesWithChannelResult.map((id: any) => dataItem.push(id.dateTime));
    }

    useEffect(() => {
        setdateTimeList(finalDate);
    }, []);

    const radioBtnChange = (event: any): void => {
        setPdConversion(event.target.value);
    };

    const cHNumber: any = [];
    datesWithChannelResult.map((item: any) => {
        if (item.dateTime === dataItem[selectedDateIndex]) {
            if (item.channels.length === 0) {
                emptyChannels = true;
            } else {
                return item.channels.map((items: any) => cHNumber.push(items.channelNumber));
            }
        }
        return true;
    });

    const useFilter = (event: any): void => {
        setFilterChecked(event.target.checked);
    };

    return (
        <>
            <Grid container>
                <Grid style={{ display: props.isDisabled === true ? 'none' : 'block' }} item xs={2}>
                    <Typography variant={'body2'} style={{ marginBottom: '10px' }}>
                        {t('PHASERESOLVEDGRAPH.PPC_PULSE_PER_CYCLE')}
                    </Typography>
                    <div className={classes.boxContent} style={{ backgroundColor: PXBColors.black[800] }}>
                        <span className={classes.colorSpan}>0 - 0.45</span>
                    </div>
                    <div className={classes.boxContent} style={{ backgroundColor: PXBColors.lightBlue[500] }}>
                        <span className={classes.colorSpan}>0.425 - 0.875</span>
                    </div>
                    <div className={classes.boxContent} style={{ backgroundColor: '#00ffff' }}>
                        <span className={classes.colorSpan}>0.875 - 1.3</span>
                    </div>
                    <div className={classes.boxContent} style={{ backgroundColor: PXBColors.purple[500] }}>
                        <span className={classes.colorSpan}> 1.3 - 2.5</span>
                    </div>
                    <div className={classes.boxContent} style={{ backgroundColor: PXBColors.red[900] }}>
                        <span className={classes.colorSpan}>2.5 - 6.25</span>
                    </div>
                    <div className={classes.boxContent} style={{ backgroundColor: PXBColors.yellow[400] }}>
                        <span className={classes.colorSpan}> {'>'} 6.25 </span>
                    </div>
                    <Box sx={{ m: '25px 0px' }}>
                        <Typography variant={'body2'}>{t('PHASERESOLVEDGRAPH.Y_AXIS')}</Typography>
                        <Typography variant={'body2'}>{t('PHASERESOLVEDGRAPH.X_AXIS')}</Typography>
                    </Box>

                    <Box sx={{ m: '25px 0px 0px 0px' }}>
                        <Typography variant={'body2'}>{t('PHASERESOLVEDGRAPH.SELECT_X_AXIS')}</Typography>
                    </Box>
                    <Box>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={pdConversion}
                            onChange={radioBtnChange}
                        >
                            <FormControlLabel
                                value="Magn,mV"
                                control={<Radio style={{ margin: '6px 4px 4px 10px', padding: '0px' }} />}
                                label="PD Magn, mV"
                            />
                            <FormControlLabel
                                value="Charge,nC"
                                control={<Radio style={{ margin: '6px 4px 4px 10px', padding: '0px' }} />}
                                label="PD Charge, nC"
                            />
                        </RadioGroup>
                    </Box>

                    <Box sx={{ m: '25px 0px 0px 0px' }}>
                        <Typography variant={'body2'}>{t('PHASERESOLVEDGRAPH.AXIS_INFORMATION')}</Typography>
                    </Box>
                    <Box>
                        <FormControlLabel
                            control={
                                <Checkbox disabled={true} style={{ margin: '6px 4px 4px 10px', padding: '0px' }} />
                            }
                            label=" Show Sine"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={filterchecked}
                                    style={{ margin: '6px 4px 4px 10px', padding: '0px' }}
                                    onChange={useFilter}
                                />
                            }
                            label="Use filters"
                        />
                    </Box>
                </Grid>

                <Grid item xs={props.isDisabled === true ? 12 : 10}>
                    <Paper>
                        <DataIndicators
                            errorMessage="Record not found"
                            emptyMessage="Record not found"
                            data={getResponseData}
                            emptyIcon="BarChart"
                            isEmpty={isEmpty}
                            isDetailedInfo={false}
                        />
                        <div style={{ padding: props.isDisabled === true ? '0px' : '16px', backgroundColor: '#fff' }}>
                            <Grid
                                container
                                style={{ marginBottom: props.isDisabled === true ? '0px' : '20px' }}
                                data-testid="dropdown-dateTime"
                            >
                                {isDataLoaded(getResponseData) && getResponseData.value.datesWithChannel.length > 0 && (
                                    <HeaderPRGraph
                                        dataItem={dataItem}
                                        setValues={setdateTimeList}
                                        setIndexValue={setScaleIndex}
                                        isDisabled={props.isDisabled}
                                        alarmSelectIndex={selectedDateIndex}
                                    />
                                )}
                            </Grid>
                            <Divider></Divider>
                            <Grid container>
                                <Grid item xs={12}>
                                    <DataEmptyIndicator
                                        icon="ShowChart"
                                        message={t('PHASERESOLVEDGRAPH.EMPTYCHANNEL')}
                                        data={getResponseData}
                                        isEmpty={emptyChannels}
                                        inline
                                    />
                                </Grid>
                            </Grid>
                            <div data-testid="device-info-PhaseResolvedGraph">
                                {isDataLoaded(getResponseData) && (
                                    <>
                                        {props.alarmDetail === true && (
                                            <Grid container justifyContent="flex-start">
                                                <Grid
                                                    item
                                                    xs={5}
                                                    style={{
                                                        borderRight: ' 1px solid lightgrey',
                                                        marginBottom: '15px',
                                                        borderBottom: ' 1px solid lightgrey',
                                                    }}
                                                >
                                                    <PhaseResolvedGraphProvider
                                                        deviceId={props.deviceId}
                                                        channelNumber={props.alarnChannelNumber}
                                                        graphDate={props.alarmGraphDate}
                                                        filterChecked={filterchecked}
                                                        pdConversion={pdConversion}
                                                    >
                                                        <PhaseResolvedGraph
                                                            channelNumber={props.alarnChannelNumber}
                                                            graphDate={props.alarmGraphDate}
                                                            filterChecked={filterchecked}
                                                            pdConversion={pdConversion}
                                                            scaleValue={scaleIndex}
                                                        />
                                                    </PhaseResolvedGraphProvider>
                                                </Grid>
                                            </Grid>
                                        )}

                                        {props.alarmDetail !== true && (
                                            <>
                                                {getResponseData.value.datesWithChannel.map(
                                                    (item) => item.channels.length > 1
                                                ) && (
                                                    <Grid container>
                                                        {cHNumber.map((location: number, index: number) => (
                                                            <Grid
                                                                key={index}
                                                                item
                                                                xs={3}
                                                                style={{
                                                                    borderRight: ' 1px solid lightgrey',
                                                                    marginBottom: '15px',
                                                                    borderBottom: ' 1px solid lightgrey',
                                                                }}
                                                            >
                                                                <PhaseResolvedGraphProvider
                                                                    key={index}
                                                                    deviceId={props.deviceId}
                                                                    channelNumber={location}
                                                                    graphDate={dataItem[selectedDateIndex]}
                                                                    filterChecked={filterchecked}
                                                                    pdConversion={pdConversion}
                                                                >
                                                                    <PhaseResolvedGraph
                                                                        channelNumber={location}
                                                                        graphDate={dataItem[selectedDateIndex]}
                                                                        filterChecked={filterchecked}
                                                                        pdConversion={pdConversion}
                                                                        scaleValue={scaleIndex}
                                                                    />
                                                                </PhaseResolvedGraphProvider>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};
